module.exports = __webpack_public_path__ + "img/1M_WU8VbdUZ7AC0-8o7TOscwOyPENF5x8.bb53f670.png";